import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

function CategoryTemplateContent(props: any) {
  const { TemplateContent } = props;
  return (
    <div
      className={ivclass(
        'iv-bg-black-4 iv-border-b-2 iv-border-t-2 iv-border-grey-10',
        'iv-px-20',
      )}
    >
      <div className={ivclass('iv-max-w-2xl iv-mx-auto iv-py-75')}>
        <div className={ivclass('iv-mb-30')}>
          <h2
            className={ivclass(
              'iv-text-body-xl iv-text-grey-70 iv-font-bold iv-m-body-xl',
            )}
          >
            {TemplateContent.Title}
          </h2>
        </div>
        <div className={ivclass()}>
          {TemplateContent.FAQ &&
            TemplateContent.FAQ.map((faq: any) => (
              <div className={ivclass('iv-mb-30')} key={faq.id}>
                <h3
                  className={ivclass(
                    'iv-text-body-m iv-text-grey-70 iv-font-bold iv-m-body-m',
                    'iv-mb-10',
                  )}
                >
                  {faq.Question}
                </h3>

                <div
                  className={ivclass(
                    'iv-text-body-m iv-text-grey-60 iv-font-medium iv-m-body-m',
                  )}
                  dangerouslySetInnerHTML={{
                    __html: faq.Answer,
                  }}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default CategoryTemplateContent;
